import React from 'react'
import {Link} from "react-router-dom";

import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import mainmenu from "../images/RANNABATI MENU 2025_page-0002.jpg"
import ReactWhatsapp from "react-whatsapp";
import khabarebangaliana from "../images/RANNABATI MENU 2025_page-0003.jpg";
import khabarebangaliana_rannabati from "../images/RANNABATI MENU 2025_page-0004.jpg"
import strater from "../images/RANNABATI MENU 2025_page-0005.jpg";
import statrnonveg from "../images/RANNABATI MENU 2025_page-0006.jpg"
import chinese from "../images/RANNABATI MENU 2025_page-0007.jpg";
import chinesespecialveg from "../images/RANNABATI MENU 2025_page-0008.jpg";
import indianspecial from "../images/RANNABATI MENU 2025_page-0009.jpg"
import dal from "../images/RANNABATI MENU 2025_page-0010.jpg";
import vegspecial from "../images/RANNABATI MENU 2025_page-0011.jpg";
import tandoorspecial from "../images/RANNABATI MENU 2025_page-0012.jpg";
import tandoorspecial2 from "../images/RANNABATI MENU 2025_page-0013.jpg";
import beverages from "../images/RANNABATI MENU 2025_page-0014.jpg";


import menunew from "../images/RANNABATI MENU 2025.pdf";


function Menu() {
    return (
        <div>

         
      <div className='menunew25'>
        <div className="album py-2">
          <div className="container mt-2">
            <h3 className='mb-0' style={{ color: "white" }}> Rannabati Family Restaurant </h3>
            <hr className='mb-1' style={{ color: "white" }} />
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" style={{ color: "white" }} >Home</Link></li>

                <li className="breadcrumb-item"><Link to="/restaurant" style={{ color: "white" }} >Back</Link></li>
                <li style={{ color: "white" }} className="breadcrumb-item active" aria-current="page"> Menu</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

       <div style={{ color: "Green" }} className="fixed-bottom "> <ReactWhatsapp number="+91  9609612912" className="whatsappbutton" message="I am Interested"> <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
                      <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                  </svg> </ReactWhatsapp></div>
      <div className='album py-2'>
        <div className='container'>
          <div className="row">
            <div className="col-md-4 mt-3">
              <a href={menunew} target="_blank" rel="noopener noreferrer">
                <button className='buttonmenu'> MENU DOWNLOAD <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-cloud-download" viewBox="0 0 16 16">
                  <path d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383" />
                  <path d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708z" />
                </svg></button>
              </a>
            </div>


            <div className='album py-2'>
              <div className='container'>
                <div className="row">
                  <div className="col-md-3 mt-2">
                    <div className='imgradius'>
                      <Zoom>
                        <img src={mainmenu} className="card-img-top" alt="rannabati menu" />
                      </Zoom>
                    </div>
                  </div>
                  <div className="col-md-3 mt-2">
                    <div className='imgradius'>
                      <Zoom>
                        <img src={khabarebangaliana} className="card-img-top" alt="vilasvojakhabarebangaliana"/>
                      </Zoom>
                    </div>
                  </div>
                  <div className="col-md-3 mt-2">
                    <div className='imgradius'>
                      <Zoom>
                        <img src={khabarebangaliana_rannabati} className="card-img-top" alt="khabarebangaliana_rannabati"/>
                      </Zoom>
                    </div>
                  </div>
                  <div className="col-md-3 mt-2">
                    <div className='imgradius'>
                      <Zoom>
                        <img src={strater} className="card-img-top" alt="strater menu rannabati"/>
                      </Zoom>
                    </div>
                  </div>
                  <div className="col-md-3 mt-2">
                    <div className='imgradius'>
                      <Zoom>
                        <img src={statrnonveg} className="card-img-top" alt="statrnonveg"/>
                      </Zoom>
                    </div>
                  </div>

                   <div className="col-md-3 mt-2">
                    <div className='imgradius'>
                      <Zoom>
                        <img src={chinese} className="card-img-top" alt="chinese"/>
                      </Zoom>
                    </div>
                  </div>


                   <div className="col-md-3 mt-2">
                    <div className='imgradius'>
                      <Zoom>
                        <img src={chinesespecialveg} className="card-img-top" alt="chinesespecialveg"/>
                      </Zoom>
                    </div>
                  </div>


                   <div className="col-md-3 mt-2">
                    <div className='imgradius'>
                      <Zoom>
                        <img src={indianspecial} className="card-img-top" alt="indianspecial"/>
                      </Zoom>
                    </div>
                  </div>


                   <div className="col-md-3 mt-2">
                    <div className='imgradius'>
                      <Zoom>
                        <img src={dal} className="card-img-top" alt="dal"/>
                      </Zoom>
                    </div>
                  </div>


                   <div className="col-md-3 mt-2">
                    <div className='imgradius'>
                      <Zoom>
                        <img src={vegspecial} className="card-img-top" alt="vegspecial"/>
                      </Zoom>
                    </div>
                  </div>


                   <div className="col-md-3 mt-2">
                    <div className='imgradius'>
                      <Zoom>
                        <img src={tandoorspecial} className="card-img-top" alt="tandoorspecial"/>
                      </Zoom>
                    </div>
                  </div>

                   <div className="col-md-3 mt-2">
                    <div className='imgradius'>
                      <Zoom>
                        <img src={tandoorspecial2} className="card-img-top" alt="tandoorspecial"/>
                      </Zoom>
                    </div>
                  </div>

                   <div className="col-md-3 mt-2">
                    <div className='imgradius'>
                      <Zoom>
                        <img src={beverages} className="card-img-top" alt="beverages"/>
                      </Zoom>
                    </div>
                  </div>

                </div>

              </div>
            </div>
            <div className="col-md-8 mt-3">

            </div>
          </div>
        </div>
      </div>
            {/* <div className='album py-0'>
                <div className='container'>
                    <div className='row' >
                        <div className="col-md-6 mt-2">

                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <div className="card mb-3 me-2">
                                    <div className="row g-0">
                                        <div className="col-md-4">
                                            <a href='#breakfast'>
                                                <img src={Breakfast} className="img-fluid rounded-start" alt="Ranna_Bati" />
                                            </a>
                                        </div>
                                        <div className="col-md-8">
                                            <a href='#breakfast'>
                                                <div className="card-body">
                                                    <h6 style={{ color: "grey" }} className="card-title ">BREAK FAST</h6>
                                                    <p className="card-text"> <small>(7:30 A.M to 10 A.M)</small></p>

                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>


                                <div className="card mb-3 me-2">
                                    <div className="row g-0">
                                        <div className="col-md-4">
                                            <a href='#bangaliana'>
                                                <img src={khabarebangali} className="img-fluid rounded-start" alt="Ranna_Bati" />
                                            </a>
                                        </div>
                                        <div className="col-md-8 ">
                                            <div className="card-body ">
                                                <a href='#bangaliana'>
                                                    <h6 style={{ color: "grey" }} className="card-title mb-0"><small>Khabare Bangaliana</small></h6>
                                                    <p className="card-text"> <small> ছোট বাটি & বড় বাটি </small></p>
                                                </a>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                       

<div className="col-md-6 mt-2">

<div className="d-flex justify-content-between align-items-center mb-2">
    <div className="card mb-3 me-2">
        <div className="row g-0">
            <div className="col-md-4">
                <a href='#chinese'>
                    <img src={Chanieese} className="img-fluid rounded-start" alt="Ranna_Bati" />
                </a>
            </div>
            <div className="col-md-8">
                <a href='#chinese'>
                    <div className="card-body">
                        <h6 style={{ color: "grey" }} className="card-title mb-0">Chaniese</h6>
                        <p className="card-text"> <small> Chowmin / Rice </small></p>
              

                    </div>
                </a>
            </div>
        </div>
    </div>


    <div className="card mb-3 me-2">
        <div className="row g-0">
            <div className="col-md-4">
                <a href='#indianspecial'>
                    <img src={indianspecial} className="img-fluid rounded-start" alt="Ranna_Bati" />
                </a>
            </div>
            <div className="col-md-8 ">
                <div className="card-body ">
                    <a href='#indianspecial'>
                        <h6 style={{ color: "grey" }} className="card-title mb-0"><small>Indian Special</small></h6>
                        <p className="card-text"> <small>  Rice / Roti </small></p>

                    </a>

                </div>
            </div>
        </div>
    </div>
</div>
</div>
                        <div className="col-md-6 mt-2">

                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <div className="card mb-3 me-2">
                                    <div className="row g-0">


                                        <div className="col-md-4">
                                            <a href='#tandoor'>
                                                <img src={Tandoors} className="img-fluid rounded-start" alt="rannabati" />
                                            </a>
                                        </div>
                                        <div className="col-md-8">
                                            <a href='#tandoor'>
                                                <div className="card-body">
                                                    <h6 style={{ color: "grey" }} className="card-title mb-0">Tandoor Special</h6>
                                                    <p className="card-text mb-0"> <small>(14 type)</small></p>
                                                </div>
                                            </a>
                                        </div>

                                    </div>
                                </div>
                                <div className="card mb-3 me-2">
                                    <div className="row g-0">
                                        <div className="col-md-4">
                                            <a href='#thali'>
                                                <img src={specialthali} className="img-fluid rounded-start" alt="rannabati" />
                                            </a>
                                        </div>
                                        <div className="col-md-8">
                                            <div className="card-body ">
                                                <a href='#thali'>

                                                    <h6 style={{ color: "grey" }} className="card-title mb-0">Thali</h6>
                                                    <p className="card-text"> <small> স্পেশাল থালি </small></p>
                                                </a>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                   

                    </div>
                </div>
            </div>

            <div className='album py-0'>
                <div className='container'>
                    <div className='row' >
                        <div className="col-md-6 mt-2">
                            <Breakfasts />
                        </div>
                        <div className="col-md-6 mt-3">
                            <br />
                            <br />

                            <div className='krishnagarrestro'>
                                <img src={Break} className="card-img-top mb-3" alt="rannbati" />
                                <img src={Breakimage} className="card-img-top" alt="rannbati" />
                            </div>


                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div className='album py-0'>
                <div className='container'>
                    <div className='row' >
                        <div className="col-md-6 mt-2">
                            <Tandoor />
                        </div>
                        <div className="col-md-6 mt-3">
                            <br />
                            <br />

                            <div className='krishnagarrestro'>
                                <img src={tandoor} className="card-img-top mb-3" alt="rannbati" />

                            </div>


                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div className='album py-0'>
                <div className='container'>
                    <div className='row' >
                        <div className="col-md-6 mt-2">
                            <Bangaliana />
                        </div>
                        <div className="col-md-6 mt-3">
                            <br />
                            <br />

                            <div className='krishnagarrestro'>
                                <img src={Bangali} className="card-img-top mb-3" alt="rannbati" />

                            </div>


                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div className='album py-0'>
                <div className='container'>
                    <div className='row' >
                        <div className="col-md-6 mt-2">
                            <Chinese/>
                        </div>
                        <div className="col-md-6 mt-3">
                           
                            <div className='krishnagarrestro'>
                                <img src={Chowmin} className="card-img-top mb-3" alt="rannbati" />

                            </div>


                        </div>
                    </div>
                </div>
            </div>
            <div className='album py-0'>
                <div className='container'>
                    <div className='row' >
                        <div className="col-md-6 mt-2">
                            <Indianspecial/>
                        </div>
                        <div className="col-md-6 mt-3">
                           
                            <div className='krishnagarrestro'>
                                <img src={Rice} className="card-img-top mb-3" alt="rannbati" />

                            </div>


                        </div>
                    </div>
                </div>
            </div>
            <div className='album py-0'>
                <div className='container'>
                    <div className='row'>
                        <div className="col-md-6 mt-2">
                            <Thali />
                        </div>

                        <div className="col-md-6 mt-3">


                            <div className='krishnagarrestro'>
                                <img src={Thalis} className="card-img-top " alt="rannbati" />

                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            <br />
            <br />
        </div>
    )
}

export default Menu